import type { GeneratedInsight } from "@amzn/d16-g-client-deck-builder-typescript-client";
import { Status } from "@amzn/d16-g-client-deck-builder-typescript-client";
import { GeneratedInsightType } from "@amzn/d16-g-client-deck-builder-typescript-client";
import { differenceInSeconds } from "date-fns";
import maxDates from "date-fns/max";
import * as R from "remeda";

export const insightTypeLabelLookup = {
    [GeneratedInsightType.WB]: "Workbench Compiled",
    [GeneratedInsightType.PKG]: "Packaged",
};

export const getGeneratedInsightsRefreshInterval = (
    insights: GeneratedInsight[],
): number | undefined => {
    const quickIntervalRefreshRateMS = 5000; // 5 seconds;
    const intervalRefreshRateMS = 300000; // 5 minutes;
    const quickIntervalMaxWaitSeconds = 120; // 2 minutes;

    // Find the most recent updateTimestamp as a Date
    const mostRecentDate = R.pipe(
        insights,
        R.map((e) => (e.updateTimestamp ? new Date(e.updateTimestamp) : null)),
        R.filter(R.isDate),
        maxDates,
    );
    // Compare to current Date
    const differenceSeconds = Math.abs(
        differenceInSeconds(mostRecentDate, new Date()),
    );
    if (Number.isNaN(differenceSeconds)) {
        return undefined;
    } else if (differenceSeconds <= quickIntervalMaxWaitSeconds)
        return quickIntervalRefreshRateMS;
    else return intervalRefreshRateMS;
};

export const isSupportedGeneratedInsightType = (
    insightType: string,
): boolean => {
    return Object.values(GeneratedInsightType).includes(
        insightType as GeneratedInsightType,
    );
};

export const isSuccess = (status?: Status): boolean =>
    status === Status.SUCCESS;
